<div class="flex flex-col gap-10">
  <p-card header="Adres zamieszkania" tabindex="0" class="custom-card">
    <app-preview-address
      [address]="beneficiary()?.adres || undefined"
    ></app-preview-address>
    <div tabindex="0">
      <br />
      <app-preview-data-wrapper
        class="custom-card"
        [label]="'Adres korespondencyjny inny niż adres zamieszkania'"
        [data]="beneficiary()?.czyAdresKorespondencyjny"
        [dataType]="PreviewDataType.CHECKBOX"
      ></app-preview-data-wrapper>
    </div>
  </p-card>
  @if (beneficiary()?.czyAdresKorespondencyjny) {
    <p-card header="Adres korespondencyjny" tabindex="0" class="custom-card">
      <app-preview-address
        [address]="beneficiary()?.adresKorespondencyjny || undefined"
      ></app-preview-address>
    </p-card>
  }
</div>
